export const CustomSnapshot = Symbol('bytereplay.CustomSnapshot');
export function isCustomSnapshotElement(element) {
    return element[CustomSnapshot] !== undefined;
}
